import script from "./CreateAccount.vue?vue&type=script&setup=true&lang=ts"
export * from "./CreateAccount.vue?vue&type=script&setup=true&lang=ts"

import "./CreateAccount.vue?vue&type=style&index=0&id=c39b00fa&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c39b00fa"]])

export default __exports__